import { NOTIFICATION } from '~/consts';

export const state = () => ({
  list: [],
  count_unread: 0,
  snack_bars: [],
  get_list_loading: false,
  list_has_been_taken: null,
  alerts: [],
})

export const mutations = {
  pushNotif(state, notification) {
    state.list = collect(state.list).prepend(notification).toArray();
  },
  setList(state, notifications) {
    state.list = notifications;
  },
  setCountUnread(state, unread) {
    state.count_unread = unread;
  },
  pushAlert(state, alert) {
    state.alerts = collect(state.alerts).prepend(alert).toArray()
  },
  removeAlert(state, alertKey) {
    state.alerts = _.cloneDeep(collect(state.alerts)).filter(alert => {
      if (alert.key == alertKey) {
        return false
      }

      return true
    }).all()
  },
  removeSnackBar(state, key) {
    state.snack_bars = state.snack_bars.filter((i, k) => key === k + 1);
  },
  addSnackBar(state, notification) {
    state.snack_bars = state.snack_bars
      .filter(notif => notif.msg !== notification.msg)
      .concat([notification]);
  },
  setListLoading(state, value) {
    state.get_list_loading = value;
  },
  setListHasBeenTaken(state, value) {
    state.list_has_been_taken = value;
  }
}

export const actions = {
  getList({ commit, state, dispatch }, popup = false) {
    const vm = this;

    commit('setListLoading', true);

    this.$axios.post(NOTIFICATION.GET_ALL, {
      dataProvider: JSON.stringify({
        "criterion": [],
        "page": {
          "count": 0,
          "current": 1,
          "limit": 5,
          "next": 0,
          "previous": 0,
          "total": 0
        },
        "sort": []
      })
    }).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        const data_notif = collect(data.data.data).map((n) => {
          let click_action = '';

          if (!helpers.isEmpty(n.group)) {
            let group_path = n.group.type == 'A' ? 'classes' : 'groups'

            if ([4, 5, 6, 7].indexOf(parseInt(n.type)) > -1) {
              if (!helpers.isEmpty(n.postId)) {
                click_action = helpers.getPostDetailUrl({
                  ...n.post,
                  groupId: n.group.id,
                  group: n.group,
                  section: {
                    id: n.post.classScheduleId,
                  }
                });
              } else {
                click_action = `/panel/${group_path}/${n.groupId}`
              }
            } else if (n.type == 1) {
              click_action = `/panel/${group_path}/${n.groupId}/classmate`
            } else if (n.type == 11) {
              click_action = `/panel/${group_path}/${n.groupId}/info`
            }
          }

          return {
            id: n.id,
            title: n.title,
            body: n.description,
            is_read: n.status == 'SENT' ? 0 : 1,
            type: n.type,
            click_action,
            createdAt: n.createdAt
          }
        }).toArray();

        commit('setList', data_notif);
        commit('setListLoading', false);
        commit('setListHasBeenTaken', true);

        if (popup) {
          let last_notif = data_notif[0];
          snackbar.default(last_notif.body, {
            actionText: 'Lihat',
            onAction: () => {
              dispatch('setRead', last_notif.id);

              vm.$router.push({ path: last_notif.click_action })
            }
          })
        }
      }
    }).catch(() => {
      commit('setListLoading', false);
      commit('setListHasBeenTaken', null);
    });
  },
  getCountUnread({ commit, state }) {
    this.$axios.post(NOTIFICATION.GET_COUNT_UNREAD)
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          commit('setCountUnread', data.data.unreadCount);
        }
      }
    );
  },
  setRead({ dispatch }, id) {
    this.$axios.post(NOTIFICATION.SET_READ(id))
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          dispatch('getList');
          dispatch('getCountUnread');
        }
      })
  },
  async setAllRead({ dispatch }, callback) {
    this.$axios.post(NOTIFICATION.SET_ALL_READ)
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          dispatch('getList');
          dispatch('getCountUnread');
          callback();
        }
      })
  },
  pushNotif({ commit }, notif) {
    commit('pushNotif', notif);
  },
  pushAlert({ commit }, alert) {
    alert.key = new Date().getTime()

    commit('pushAlert', alert);

    setTimeout(() => {
      commit('removeAlert', alert.key)
    }, 5000)
  },
  removeAlert({ commit }, alertKey) {
    commit('removeAlert', alertKey)
  }
}
